import { HttpClient } from "@angular/common/http";
import { BaseService } from "../../../shared/Services/BaseService";
import { authenticationService } from "../../../shared/Services/authenticationService";
import { environment } from "../../../../../environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RequestLoggingService extends BaseService {

   constructor(http: HttpClient, authenticationSerives: authenticationService) {
      const baseUrl = environment.apiUrl + 'RequestLogging';
  
      super(http, authenticationSerives, baseUrl);
   }
  }

